module.exports = __webpack_public_path__ + "img/PR.58aa99ae.svg";